export default {
  install: (Vue) => {
    const Templates = require.context('./../layout/', true, /\.vue$/)
    Templates.keys().forEach(key => {
      const Template = Templates(key).default
      Vue.component(Template.name, Template)
    })
  }
}